import PolicyLayout from "@/components/PolicyLayout";

const sections = [
    {
        heading: "1. Our commitment",
        body: [
            "We take every complaint seriously. We aim to acknowledge complaints within two business days and to resolve them within thirty calendar days of receipt. Where a complaint is more complex we will keep you informed of progress and expected timeframes.",
        ],
    },
    {
        heading: "2. Before you submit",
        body: [
            "Most issues can be resolved quickly by emailing info@nexuspeptides.online with your order reference, a description of the problem, and any supporting photographs or documentation. If your initial enquiry has not been resolved to your satisfaction, you can escalate it via the formal procedure below.",
        ],
    },
    {
        heading: "3. How to submit a formal complaint",
        body: ["Send your complaint to info@nexuspeptides.online with the following information:"],
        list: [
            "Your full name and the email address associated with your account.",
            "Your order reference (format NXP-XXXXXXXX), if applicable.",
            "A clear description of the issue, including dates and any relevant context.",
            "What outcome you are seeking — for example replacement, refund, or written explanation.",
            "Any supporting evidence: photographs, lot numbers, certificate-of-analysis references, or correspondence.",
        ],
    },
    {
        heading: "4. What happens next",
        body: ["Once a complaint is received we will:"],
        list: [
            "Acknowledge receipt within two business days and assign a complaint reference.",
            "Investigate the issue, which may include consulting our partner lab for product-quality matters.",
            "Provide you with a written response setting out our findings and any proposed resolution.",
            "Where appropriate, take corrective action to prevent recurrence and document the outcome.",
        ],
    },
    {
        heading: "5. Escalation",
        body: [
            "If you are not satisfied with our response you can request that a senior member of staff review the matter. A different reviewer will consider the case afresh and respond within fifteen business days.",
        ],
    },
    {
        heading: "6. External recourse",
        body: [
            "If after exhausting our internal procedure you remain dissatisfied, you may seek advice or escalation through the relevant consumer-protection authority in your jurisdiction. We will cooperate fully with any legitimate regulatory enquiry.",
        ],
    },
    {
        heading: "7. Record keeping",
        body: [
            "We keep a confidential record of every complaint, our response, and any corrective action taken. This data is retained in line with our Privacy Policy and is used to identify recurring issues and improve the service.",
        ],
    },
    {
        heading: "8. Contact",
        body: [
            "Direct complaints to info@nexuspeptides.online. General customer-service enquiries should still go to info@nexuspeptides.online.",
        ],
    },
];

export default function Complaints() {
    return (
        <PolicyLayout
            eyebrow="// Customer care"
            title="Complaints procedure"
            intro="If something has gone wrong we want to put it right. This page sets out how to raise a complaint with Nexus Peptides and what you can expect from us at each stage."
            sections={sections}
            footer="If your complaint relates specifically to the quality of a research compound — for example purity, contamination, or non-conformance with the Certificate of Analysis — we will refer the matter to our partner lab's QA team and provide their findings as part of our response."
        />
    );
}
